import React from 'react';
import { withGoogleMap, GoogleMap } from 'react-google-maps';
import './style.scss';
import LoadingIndicator from 'src/components/LoadingIndicator';

const MapWrapper = withGoogleMap((props) => (
  <GoogleMap
    defaultOptions={{
      fullscreenControl: false,
      mapTypeControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_BOTTOM
      }
    }}
    {...props}
  />
));

class Map extends React.Component {
  render() {
    const { height, width } = this.props;
    return (
      <MapWrapper
        loadingElement={<LoadingIndicator />}
        containerElement={
          <div className="map-container" style={{ height, width }} />
        }
        mapElement={<div className="map" />}
        {...this.props}
      />
    );
  }
}

export default Map;
